import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { DashboardContent } from '@/layouts/dashboard';
import { FilterSelectNative } from '@/components/custom/filter';
import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import { TiaBanner } from '@/components/custom/tia-banner';
import { EssayPlayfulCard } from './EssayCard';
import tiaRedacao from '@/assets/images/tia/TIA-REDACAO-CONVITE.png';

export default function EssayPlayful({ uri }) {
  const client = useClient();
  const [courses, setCourses] = useState([]);
  const [essays, setEssays] = useState([]);
  const [loading, setLoading] = useState(true);

  const filters = useFormik({
    initialValues: {
      course: 'blank'
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [coursesResponse, essaysResponse] = await Promise.all([client.fetch('courses/simple'), client.fetch('essays')]);

        if (coursesResponse.error) {
          toast.error('Erro ao carregar cursos');
        } else {
          setCourses(coursesResponse.data || []);
        }

        if (essaysResponse.error) {
          toast.error('Erro ao carregar redações');
        } else {
          setEssays(essaysResponse.data || []);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredEssays = essays.filter(essay => filters.values.course === 'blank' || essay?.['courses-ids']?.includes(Number(filters.values.course)));

  const breadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: uri,
        name: 'Redação',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <TiaBanner
        className="mb-6 mt-20"
        image={tiaRedacao}
        bubbleMaxWidth={800}
        text="Praticar toda semana é o que mais ajuda na hora da prova. Leva só alguns minutos e eu te ajudo na correção. 🤩"
      />

      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <FilterSelectNative
          label="Selecione um curso"
          value={filters.values.course}
          onChange={e => filters.setFieldValue('course', e.target.value)}
          blankLabel="Todos os cursos"
          options={courses.map(o => ({ id: o.id, name: o.title }))}
        />

        <a
          href="/redacao.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="block shrink-0 rounded-full px-5 py-2.5 text-sm font-extrabold text-white transition-transform duration-100 active:translate-y-px"
          style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
        >
          Baixar folha de redação
        </a>
      </div>

      {loading && <Loader />}

      {!loading && filteredEssays.length === 0 && (
        <EmptyState
          type="content"
          variant="plain"
          className="pt-32"
        />
      )}

      {!loading && filteredEssays.length > 0 && (
        <div className="grid animate-fade-in grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filteredEssays.map(essay => (
            <EssayPlayfulCard
              key={essay.id}
              essay={essay}
            />
          ))}
        </div>
      )}
    </DashboardContent>
  );
}
